// extracted by mini-css-extract-plugin
export default {"base":"ActionDeleted_base__wRu7q"};